import { Type } from '@sinclair/typebox';
import { newClientError } from '../core/client-error.js';
import { createClientError } from '../core/create-client-error.js';
export const GenericError = createClientError('GENERIC_ERROR', Type.Object({ message: Type.Optional(Type.String()) }));
export function newGenericError(status, message) {
    return newClientError({
        status,
        type: 'GENERIC_ERROR',
        data: message === undefined ? {} : { message },
    });
}
